import api from './client';
import type { Booking } from 'types/booking';

export const bookingsApi = {
  list: async (params?: { org_id?: string; status?: string; limit?: number; offset?: number }): Promise<Booking[]> => {
    const { data } = await api.get('/bookings', { params });
    return data;
  },

  get: async (id: string): Promise<Booking> => {
    const { data } = await api.get(`/bookings/${id}`);
    return data;
  },

  create: async (booking: Omit<Booking, 'id' | 'created_at' | 'status'>): Promise<Booking> => {
    const { data } = await api.post('/bookings', booking);
    return data;
  },

  update: async (id: string, updates: Partial<Booking>): Promise<Booking> => {
    const { data } = await api.patch(`/bookings/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/bookings/${id}`);
  },

  getFullDays: async (month: string, orgId?: string): Promise<{ month: string; max_per_day: number; full_days: string[] }> => {
    const { data } = await api.get('/bookings/full-days', { params: { month, org_id: orgId } });
    return data;
  },

  getAvailability: async (date: string, serviceType: string, orgId?: string): Promise<{ date: string; service_type: string; unavailable_slots: string[] }> => {
    const { data } = await api.get('/bookings/availability', { params: { date, service_type: serviceType, org_id: orgId } });
    return data;
  },

  lookupClient: async (phone: string, orgId?: string): Promise<{ found: boolean; dossier_id?: string; nom?: string; prenom?: string; email?: string; phone?: string }> => {
    const { data } = await api.get('/bookings/lookup-client', { params: { phone, org_id: orgId } });
    return data;
  },

  lookupVehicle: async (plate: string, orgId?: string): Promise<{ found: boolean; vehicle_id?: string; plate?: string; marque?: string; modele?: string; km?: number; image_url?: string }> => {
    const { data } = await api.get('/bookings/lookup-vehicle', { params: { plate, org_id: orgId } });
    return data;
  },
};
